import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrudComponent } from './crud/crud.component';
import { ListComponent } from './list/list.component';
import { LogsComponent } from './logs/logs.component';

const routes: Routes = [
  {
    path: "add",
    component: CrudComponent
  },
  {
    path: "view/:id",
    component: CrudComponent
  },
  {
    path: "manage",
    component: ListComponent
  },
  {
    path: 'logs',
    component: LogsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmailTemplatesRoutingModule { }
